// extracted by mini-css-extract-plugin
module.exports = {"container":"_539c49cd","swiperList":"_352474c2","spinner":"_d67ac7d7"};